import { zodResolver } from '@hookform/resolvers/zod';
import { useRequestOTP } from '@waitroom/auth';
import { toBoolean } from '@waitroom/utils';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { defaultValues } from './RegisterForm.constants';
import validationSchema from './RegisterForm.schema';
import { RegisterFormValues, UseRegisterFormProps } from './RegisterForm.types';

export const useRegisterForm = ({
  onSubmit,
  onSuccess,
  onError,
  redirectUrl,
  clientId,
  state,
  codeChallenge,
}: UseRegisterFormProps) => {
  const { t } = useTranslation();
  const schema = useMemo(() => validationSchema(t), [t]);
  const methods = useForm<RegisterFormValues>({
    resolver: zodResolver(schema),
    defaultValues,
  });
  const { reset } = methods;
  const mutation = useRequestOTP({
    onMutate: onSubmit,
    onSuccess: (...args) => {
      reset();
      onSuccess?.(...args);
    },
    onError,
  });

  const submit = async (values: RegisterFormValues) => {
    mutation.mutate({
      ...values,
      marketingOptIn: toBoolean(values.marketingOptIn),
      isSignup: true,
      redirectUrl,
      clientId,
      state,
      codeChallenge,
    });
    return true;
  };
  return { t, methods, submit, mutation };
};
